import { api } from '../api';
import { useQuery, UseQueryResult } from 'react-query';
import { ChecklistItem } from '../types/checklist';
import { AxiosError } from 'axios';

type GetChecklistItemResponse = {
    checklistItem: ChecklistItem;
};

async function getChecklistItem(checklistId: string, id?: string): Promise<GetChecklistItemResponse> {
    const { data } = await api.get(`/checklists/${checklistId}/items/${id}`);
    return data;
}

export function useChecklistItem(checklistId: string, id?: string): UseQueryResult<GetChecklistItemResponse, AxiosError> {
    return useQuery(['checklist-items', id], () => getChecklistItem(checklistId, id), {
        keepPreviousData: true,
        enabled: Boolean(id),
    });
}
